import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onCreateGoal }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="bg-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="Target" size={40} color="var(--color-primary)" />
        </div>
        
        <h3 className="text-2xl font-bold text-foreground mb-3">No Goals Yet</h3>
        <p className="text-muted-foreground mb-6">
          Start planning your financial future by creating your first life goal. 
          Whether it's buying a car, home, or planning for education, we'll help you achieve it.
        </p>

        <Button
          variant="default"
          size="lg"
          iconName="Plus"
          iconPosition="left"
          onClick={onCreateGoal}
        >
          Create Your First Goal
        </Button>

        <div className="mt-8 grid grid-cols-2 gap-4 text-left">
          <div className="bg-muted/50 rounded-lg p-4">
            <Icon name="Car" size={24} color="var(--color-primary)" className="mb-2" />
            <p className="text-sm font-medium text-foreground">Car Purchase</p>
            <p className="text-xs text-muted-foreground">Plan for your dream vehicle</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <Icon name="Home" size={24} color="var(--color-accent)" className="mb-2" />
            <p className="text-sm font-medium text-foreground">Home Purchase</p>
            <p className="text-xs text-muted-foreground">Save for your own house</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <Icon name="GraduationCap" size={24} color="var(--color-warning)" className="mb-2" />
            <p className="text-sm font-medium text-foreground">Kids Education</p>
            <p className="text-xs text-muted-foreground">Secure their future</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <Icon name="Heart" size={24} color="var(--color-error)" className="mb-2" />
            <p className="text-sm font-medium text-foreground">Wedding</p>
            <p className="text-xs text-muted-foreground">Plan wedding expenses</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;